export default function (props: any) {
    return (
        <svg width="100%" height="100%" viewBox="0 0 51 52" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1474.000000, -2170.000000)">
                    <g transform="translate(1474.000000, 2170.650000)">
                        <circle cx="25.5" cy="25.5" r="25.5"></circle>
                        <path
                            d="M25,18 C20.0294373,18 16,22.0294373 16,27 C16,31.9705627 20.0294373,36 25,36 C29.9705627,36 34,31.9705627 34,27 C34,24.8607251 33.2536089,22.8957791 32.0070357,21.3513714"
                            stroke="#FFFFFF"
                            strokeWidth="3"
                            strokeLinecap="round"
                        ></path>
                        <polyline
                            stroke="#FFFFFF"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            transform="translate(22.579757, 18.579757) rotate(-48.000000) translate(-22.579757, -18.579757) "
                            points="25.1145014 16.0450128 25.1145014 21.1145014 20.0450128 21.1145014"
                        ></polyline>
                    </g>
                </g>
            </g>
        </svg>
    );
}
